module.exports = __webpack_public_path__ + "static/media/dinosaur.bf386929.mp4";